/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Bad_Date_RangeInputs */

const th_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันสิ้นสุดต้องไม่ก่อนวันเริ่มต้น`)
};

const en_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end date must be on or after the start date.`)
};

const ja_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了日は開始日と同じ日か、それより後にしてください。`)
};

const zh_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束日期必须等于或晚于开始日期。`)
};

const es_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha de fin debe ser igual o posterior a la de inicio.`)
};

const pt_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A data final precisa ser igual ou posterior à inicial.`)
};

const id_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal berakhir harus sama dengan atau setelah tanggal mulai.`)
};

const fr_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La date de fin doit être égale ou postérieure à la date de début.`)
};

const tl_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang petsa ng pagtatapos ay dapat sa o pagkatapos ng petsa ng pagsisimula.`)
};

const vi_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày kết thúc phải trùng hoặc sau ngày bắt đầu.`)
};

const ko_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`종료일은 시작일과 같거나 그 이후여야 합니다.`)
};

const de_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Enddatum muss am oder nach dem Startdatum liegen.`)
};

const ru_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата окончания должна совпадать с датой начала или быть позже.`)
};

const tr_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitiş tarihi, başlangıç tarihiyle aynı ya da ondan sonra olmalı.`)
};

const it_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La data di fine deve essere uguale o successiva a quella di inizio.`)
};

const pl_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data zakończenia musi być taka sama jak data rozpoczęcia albo późniejsza.`)
};

const uk_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата завершення має збігатися з датою початку або бути пізнішою.`)
};

const hi_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति तारीख़ आरंभ तारीख़ के बराबर या उसके बाद होनी चाहिए।`)
};

const ar_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يكون تاريخ الانتهاء مساويًا لتاريخ البدء أو بعده.`)
};

const ms_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh tamat mesti sama atau selepas tarikh mula.`)
};

const bn_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শেষের তারিখ শুরুর তারিখের সমান বা পরে হতে হবে।`)
};

const zh_tw2_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束日期必須等於或晚於開始日期。`)
};

const zh_hk2_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結束日期必須等於或晚於開始日期。`)
};

const ur_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختتامی تاریخ آغاز کی تاریخ کے برابر یا اس کے بعد ہونی چاہیے۔`)
};

const fa_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخ پایان باید برابر یا پس از تاریخ آغاز باشد.`)
};

const sw_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarehe ya mwisho lazima iwe sawa au baada ya tarehe ya kuanza.`)
};

const nl_err_bad_date_range = /** @type {(inputs: Err_Bad_Date_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De einddatum moet gelijk zijn aan of na de begindatum liggen.`)
};

/**
* | output |
* | --- |
* | "The end date must be on or after the start date." |
*
* @param {Err_Bad_Date_RangeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_bad_date_range = /** @type {((inputs?: Err_Bad_Date_RangeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Bad_Date_RangeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_bad_date_range(inputs)
	if (locale === "ja") return ja_err_bad_date_range(inputs)
	if (locale === "zh") return zh_err_bad_date_range(inputs)
	if (locale === "es") return es_err_bad_date_range(inputs)
	if (locale === "pt") return pt_err_bad_date_range(inputs)
	if (locale === "id") return id_err_bad_date_range(inputs)
	if (locale === "fr") return fr_err_bad_date_range(inputs)
	if (locale === "tl") return tl_err_bad_date_range(inputs)
	if (locale === "vi") return vi_err_bad_date_range(inputs)
	if (locale === "ko") return ko_err_bad_date_range(inputs)
	if (locale === "de") return de_err_bad_date_range(inputs)
	if (locale === "ru") return ru_err_bad_date_range(inputs)
	if (locale === "tr") return tr_err_bad_date_range(inputs)
	if (locale === "it") return it_err_bad_date_range(inputs)
	if (locale === "pl") return pl_err_bad_date_range(inputs)
	if (locale === "uk") return uk_err_bad_date_range(inputs)
	if (locale === "hi") return hi_err_bad_date_range(inputs)
	if (locale === "ar") return ar_err_bad_date_range(inputs)
	if (locale === "ms") return ms_err_bad_date_range(inputs)
	if (locale === "bn") return bn_err_bad_date_range(inputs)
	if (locale === "zh-TW") return zh_tw2_err_bad_date_range(inputs)
	if (locale === "zh-HK") return zh_hk2_err_bad_date_range(inputs)
	if (locale === "ur") return ur_err_bad_date_range(inputs)
	if (locale === "fa") return fa_err_bad_date_range(inputs)
	if (locale === "sw") return sw_err_bad_date_range(inputs)
	if (locale === "nl") return nl_err_bad_date_range(inputs)
	return en_err_bad_date_range(inputs)
});